import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/notification-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const notificationKinds = {
  getAll: apiPathFunc(pathBase),
} as const;
